// extracted by mini-css-extract-plugin
var _1 = "tJ96w";
var _2 = "gmHMd";
var _3 = "XzM3T";
var _4 = "AHtuG";
var _5 = "J9RJR";
var _6 = "bDQ46";
var _7 = "Z2IEH";
var _8 = "NcMHC";
var _9 = "ybyLX";
export { _1 as "base", _2 as "inline", _3 as "loading-dash", _4 as "loading-rotate", _5 as "size-lg", _6 as "size-md", _7 as "size-sm", _8 as "size-xl", _9 as "size-xs" }
